module.exports = __webpack_public_path__ + "img/pg-management.eb5c8a07.jpg";